<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="63" height="63" rx="31.5" fill="#FFF9C4"/>
<rect x="0.5" y="0.5" width="63" height="63" rx="31.5" stroke="#FBC02D"/>
<path d="M30 22H34M32 34L35 31M40 34C40 38.4183 36.4183 42 32 42C27.5817 42 24 38.4183 24 34C24 29.5817 27.5817 26 32 26C36.4183 26 40 29.5817 40 34Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
